export const APP_HEADER_HEIGHT = '4rem';

export const SESSION_DISPLAY_NAME_KEY = 'linesightVoterDisplayName';
export const SESSION_EMAIL_KEY = 'linesightVoterEmail';

export const FILE_UPLOAD_MAX_SIZE_BYTES = 1024 * 1024 * 20;

export const SUPPORTED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];
